
import Vue from 'vue'
import { Project } from '@/model/Project'
import Block from '@/components/Block.vue'
import ContestList from '@/components/contest/ContestList.vue'

export default Vue.extend({
  name: 'ThankYouForSharingYourProject',

  components: {
    Block,
    ContestList,
  },

  props: {
    projectSlug: {
      type: String
    },
  },

  beforeCreate() {
    if (!this.$store.state.authentication.signedIn) {
      this.$router.push('/sign-in')
    }
  },

  mounted() {
    this.fetchProject()
  },

  methods: {
    fetchProject: function () {
      this.$api
        .get('/projects/' + this.projectSlug)
        .then((response) => {
          this.project = response.data
        })
        .catch(() =>
          this.$store.dispatch(
            'alert/error',
            'Problems with fetching your sharing project.'
          )
        )
    },

    hideContestList: function (isContestListEmpty: boolean) {
      this.showContestList = !isContestListEmpty
    },
  },

  data: () => ({
    project: null as Project | null,
    showContestList: true,
    contestListFilter: 'readyForUserApplication',
  }),
})
